import React, { useState, useEffect, useCallback, useContext } from "react";
import { globalVars } from "../global/GlobalVars.js";

//========================================================================
// Browsersprache ermitteln
const initLanguage = () => {
  if (navigator.language.includes("de")) {
    //     globalVars.setLanguage("de");
  } else if (navigator.language.includes("it")) {
    globalVars.setLanguage("it");
  } else if (navigator.language.includes("en")) {
    globalVars.setLanguage("en");
  } else {
    globalVars.setLanguage("de");
  }
};

//========================================================================
// Funktion, um den Text in der richtigen Sprache anzuzeigen
const displayText = (text) => {
  try {
    switch (globalVars.language) {
      case "de":
        return text[0];
      case "it":
        if (text[1]) {
          return text[1];
        } else {
          return text[0];
        }
      case "en":
        if (text[2]) {
          return text[2];
        } else {
          return text[0];
        }
      default:
        return text[0];
    }
  } catch (error) {
    return "error";
  }
};

//========================================================================
// Funktionen exportieren
export { initLanguage, displayText };
